export default __webpack_public_path__ + "static/media/1453.2c0b5330.png";